
import axios from 'axios'
import qs from 'qs'

const translateLang =async (lang,keys) => {
  const utime = 0
  const form = {
    lang,
    utime,
    project:JSON.stringify([4]),
    keys:JSON.stringify(keys)
  }
  const res = await axios.get(`https://translate2.dokkr.net/index.php/api/get_language_file?${qs.stringify(form)}`)
  return res
}

export default translateLang